import { Component, Input } from '@angular/core';
import { Floors } from '../../models/response-floor-data';
import { CommonModule } from '@angular/common';
import { TablePaginationComponent } from 'src/app/pages/common/table-pagination/table-pagination.component';

@Component({
  selector: 'app-response-floors-data',
  standalone: true,
  imports: [CommonModule, TablePaginationComponent],
  templateUrl: './response-floors-data.component.html'
})
export class ResponseFloorsDataComponent {
    @Input() response: Floors[]=[];
     tableData:Floors[]=[];
        
    updateRecord(data:Floors[]){
      setTimeout(() => {
        this.tableData = data;
      }, 0);
    }
}
